import React, { useEffect, useRef, useState } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import { Box, Button, colors, Divider, Hidden, IconButton } from "@material-ui/core";
import { useStylesTF, useStylesLbl } from "../../../../../St/comps/UseStyle";
import ReceiptVoucherType from "../components/ReceiptVoucher-typeFilter";
import GlobleOmlatForm from "../../../../../components/controls/OmlatForm";
import { useTranslation } from "react-i18next";
import { sto } from "../../../../../Context/InshData";
import { getLS } from "../../../../../utils/useLS";
import { GetItemFromOptions } from "../../../../../services/global-services";
import RestInfoDialog from "../../../../Invs/BackEnd/models/RestInfo/RestInfoDialog";
import { CloudUpload, Search } from "@material-ui/icons";
import { menuBottonsFile, menuBottonsMultiFile } from "../../../../Invs/BackEnd/components/SearchItemsFunction";

export default function EReceiptVoucherForm(props) {
  const {
    changAutoCustomers,
    onChange,
    AutoOptions,
    changAutoBanks,
    changAutoStocks,
    object,
    onShow,
    formType,
    selectCustomer,
    valueInv,
    invOptions,
    onChangeAutoInv,
    AutoOptionsB,
    branch,
    setBranch,
    branchT,
    optionsStocks,
    handleInputSearchCust,
    optionsCustomers,
    handleIconSearchCust,
    prmis,
    setFile,
    handleDownload,
    setFiles,
    files
  } = props;
  const clasTF = useStylesTF();
  const claslbl = useStylesLbl();
  const { t } = useTranslation(["forms"]);
  const [infoData, setInfoData] = useState({ open: false });

  const locSto = getLS("sto", {});
  let locR = getLS("DataRem", {});
  const [valueUsers, setValueUsers] = useState([]);

  let id = sto.user_id;
  const getUserDefault = async (id) => {
    // alert(id)

    locSto.Users.map((x) => {
      if (x.id == id) setValueUsers(x);;
    });

  };

  const onChangeAutoData = (propName, newValue) => {
    onChange(null, { name: "branch", value: newValue.id });
    setBranch(newValue);
  };

  // const valuebranch = GetItemFromOptions(formType === "edit" &&props.isDialogData ===false?branchT:  props.isDialogData ==true?props.invData.branch : branch.id==-1??sto.branchi,AutoOptionsB.Branches??[]);
  const valuebranch = GetItemFromOptions(formType === "edit" && !props.isDialogData ? branchT : props.isDialogData ? props.invData.branch : branch.id === -1 ?? sto.branchi, AutoOptionsB.Branches ?? []);

  const getoptionlbl = (option) => {

    return `${option.id == "" ? "بدون" : 'فاتورة رقم ' + option.id + '-' + 'بمبلغ' + option.netAmount}`
  };


  useEffect(() => {
    getUserDefault(id);
  }, []);

  const getoptionCustomers = (option) => {
    return `${option?.name + '  ' + option?.acc_no ?? ""}`
  };


  const [menPostion, setMenuPostion] = useState(null);
  const openFileDialog = () => {
    fileInputRef.current.click();
  };
  const fileInputRef = useRef(null);
  const handleFileSelect = (event) => {
    const selected = event.target.files[0];
    setFile(selected);
  };
  const textfiles = files.map(x => x?.name).join(" - ");

  const handleMultiFilesSelect = (event) => {
    const selected = Array.from(event.target.files);
    setFiles(selected);
  };
  const handleClickOutLine = () => {
    setMenuPostion(null);
  };
  const handleClickInLine = (e) => {
    e.preventDefault();
    setMenuPostion({
      x: e.pageX,
      y: e.pageY,
    });
  };

  return (
    <React.Fragment>
      <Grid container style={{ paddingTop: 10, paddingBottom: 10 }} spacing={2}>
        <Grid item lg={2} md={3} sm={4} xs={6}>
          <Autocomplete
            value={branch.id == -1 ? valuebranch : branch}
            onChange={(event, newValue) => {
              onChangeAutoData("branch", newValue);
            }}
            id="controllable-states-demo"
            size="small"
            options={AutoOptionsB.Branches}
            getOptionLabel={(option) =>
              typeof option === "string" ? option : option.name
            }
            disableClearable
            disabled={formType == "edit" ? true : props.isDialogData == true ? true : sto.User_typei == 1 ? false : true}
            renderInput={(params) => (
              <TextField
                id="valueCostcenter"
                {...params}
                label={"الفرع"}
                variant="outlined"
                size="small"
                InputLabelProps={{ className: claslbl.clor }}
              />
            )}
          />
        </Grid>
        <Grid item lg={2} md={3} sm={4} xs={6}>
          <TextField
            type="text"
            fullWidth
            variant="outlined"
            size="small"
            id="id"
            label={t("voucher-id")}
            className={clasTF.rootEDS}
            InputProps={{ className: clasTF.input, readOnly: true }}
            name="id"
            value={object.id}
          />
        </Grid>
        <Grid item lg={2} md={3} sm={4} xs={6}>
          <TextField
            type="number"
            fullWidth
            variant="outlined"
            size="small"
            id="ref_no"
            label={t("ref-no")}
            className={clasTF.rootEDS}
            InputProps={{ className: clasTF.input }}
            name="ref_no"
            value={object.ref_no}
            onChange={(e) =>
              onChange(null, { name: "ref_no", value: e.target.value })
            }
          />
        </Grid>

        <Grid item lg={3} md={3} sm={4} xs={6}>
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            id="date"
            label={t("date")}
            className={clasTF.rootEDS}
            type="date"
            format="YYYY-MM-DD"
            InputLabelProps={{ shrink: true }}
            name="date"
            value={object.date}
            disabled={!prmis?.USD }
            onChange={(e) =>
              onChange(null, { name: "date", value: e.target.value })
            }
          />
        </Grid>
        <Grid item lg={3} md={3} sm={8} xs={12}>
          <Autocomplete
            value={object.center}
            onChange={(event, newValue) => {
              onChange(null, { name: "center", value: newValue });
            }}
            id="controllable-states-demo"
            size="small"
            options={AutoOptions.costcenters}
            getOptionLabel={(option) =>
              typeof option === "string" ? option : option.name
            }
            disableClearable
            renderInput={(params) => (
              <TextField
                id="valueCostcenter"
                {...params}
                label={t("center")}
                variant="outlined"
                size="small"
                InputLabelProps={{ className: claslbl.clor }}
              />
            )}
          />
        </Grid>

        <Grid item lg={6} md={9} sm={12} xs={12}>
          <Autocomplete
            value={object.customer}
            onInputChange={(event, newValue, reason) => {
              if (reason === "input") handleInputSearchCust(event, newValue, reason);
            }}
            id="combo-box-demo"
            size="small"
            options={optionsCustomers}
            getOptionLabel={(option) =>
              getoptionCustomers(option)
            }
            style={{ backgroundColor: colors.orange[50] }}
            disableClearable
            disabled={false}
            renderInput={(params) => (
              <Box size="small" display={"flex"} textAlign={"center"}>
                <TextField
                  id="valueCustomers"
                  {...params}
                  label={t("received-from-mr")}
                  // variant="outlined"
                  size="small"
                  fullWidth
                  textAlign={"center"}
                  InputLabelProps={{ className: claslbl.clor }}
                />
                <IconButton size="small" onClick={handleIconSearchCust}>
                  <Search />
                </IconButton>
              </Box>
            )}
            onChange={(event, newValue) => {
              changAutoCustomers(newValue, false);
            }}
          />
        </Grid>

        <Grid item lg={6} md={4} sm={6} xs={12}>
          <TextField
            type="number"
            fullWidth
            variant="outlined"
            size="small"
            id="val"
            label={t("amount")}
            className={clasTF.rootEDS}
            style={{ backgroundColor: colors.grey[50] }}
            InputProps={{ className: clasTF.input }}
            name="val"
            disabled={false}
            value={object.val}
            onChange={(e) => {
              const ex_value =
                object.type == "1"
                  ? object.stock_omla?.exchange
                  : object.bank_omla.exchange;
              let nObject = {
                ...object,
                val: e.target.value,
                tot_val: e.target.value * object.cust_omla.exchange,
                val1: e.target.value,
                tot_val1: e.target.value * ex_value,
              };

              onShow(nObject, formType);
            }}
          />
        </Grid>
        {selectCustomer && (
          <Grid item lg={4} md={8} sm={6} xs={12} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
            <Autocomplete value={valueInv}
              onChange={(event, newValue) => {
                onChangeAutoInv(newValue);
              }}
              id="combo-box-demo" size="small"
              options={invOptions ?? 0}
              getOptionLabel={(option) =>
                getoptionlbl(option)
              }
              style={{ color: 'black', fontWeight: "bold", fontSize: "1rem" }}
              disableClearable
              renderInput={(params) => <TextField {...params}
                InputLabelProps={{ shrink: true, className: claslbl.clrBlackLblS }} label=" الفواتير الاجلة" variant="outlined" />}
            />
          </Grid>
        )}


        <Grid item lg={8} md={8} sm={12} xs={12}>
          <GlobleOmlatForm
            {...{
              omlat: object.cust_omlat,
              omla: object.cust_omla,
              disabled: false,
              onExchangeChange: (value) => {
                let newObject = {
                  ...object,
                  cust_omla: { ...object.cust_omla, exchange: value },
                  tot_val: object.val * value,
                };
                onShow(newObject, formType);
              },
              onChange: (newValue) => {
                let newObject = {
                  ...object,
                  cust_omla: newValue,
                  tot_val: object.val * newValue.exchange,
                };
                onShow(newObject, formType);
              },
              amount: object.val,
            }}
          />
        </Grid>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Divider />
        </Grid>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <ReceiptVoucherType
            {...{
              type: object.type,
              onChange,
              prmis,
            }}
          />
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={12}>
          {object.type == "1" ? (
            <Autocomplete
              value={object.stock}
              onChange={(event, newValue) => {
                changAutoStocks(newValue);
              }}
              id="controllable-states-demoew"
              size="small"
              options={optionsStocks}
              style={{ backgroundColor: colors.orange[50] }}
              getOptionLabel={(option) =>
                typeof option === "string" ? option : option.name
              }
              disabled={formType == "edit" ? sto.User_typei == 1 ? false : true : false}
              disableClearable
              renderInput={(params) => (
                <TextField
                  id="valueCostcenter"
                  {...params}
                  label={t("deposited-in-account")}
                  variant="outlined"
                  size="small"
                  InputLabelProps={{ className: claslbl.clor }}
                />
              )}
            />
          ) :
            (
              <Autocomplete
                value={object.bank}
                onChange={(event, newValue) => {
                  changAutoBanks(newValue);
                }}
                id="controllable-states-demo67"
                size="small"
                options={AutoOptions.Banks}
                // disabled={formType == "edit"}
                disabled={formType == "edit" ? sto.User_typei == 1 ? false : true : false}
                style={{ backgroundColor: colors.orange[50] }}
                getOptionLabel={(option) =>
                  typeof option === "string" ? option : option.name
                }
                // style={{  }}
                disableClearable
                renderInput={(params) => (
                  <TextField
                    id="valueCostcenter"
                    {...params}
                    label={t("deposited-in-account")}
                    variant="outlined"
                    size="small"
                    InputLabelProps={{ className: claslbl.clor }}
                  />
                )}
              />
            )}
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={12}>
          <TextField
            type="number"
            fullWidth
            variant="outlined"
            size="small"
            id="val"
            label={t("amount")}
            className={clasTF.rootEDS}
            style={{ backgroundColor: colors.grey[50] }}
            InputProps={{ className: clasTF.input }}
            name="val1"
            disabled={false}
            value={object.val1}
            onChange={(e) => {
              const ex_value =
                object.type == "1"
                  ? object.stock_omla?.exchange
                  : object.bank_omla.exchange;
              let nObject = {
                ...object,
                val1: e.target.value,
                tot_val1: e.target.value * ex_value,
              };
              onShow(nObject, formType);
            }}
          />
        </Grid>
        <Grid item lg={8} md={8} sm={12} xs={12}>
          {object.type == "1" ? (
            <GlobleOmlatForm
              {...{
                omlat: object.stock_omlat,
                omla: object.stock_omla,
                disabled: false,
                onExchangeChange: (value) => {
                  let newObject = {
                    ...object,
                    stock_omla: { ...object.stock_omla, exchange: value },
                    tot_val1: object.val1 * value,
                  };
                  onShow(newObject, formType);
                },
                onChange: (newValue) => {
                  let newObject = {
                    ...object,
                    stock_omla: newValue,
                    tot_val1: object.val1 * newValue.exchange,
                  };
                  onShow(newObject, formType);
                },
                amount: object.val1,
              }}
            />
          ) : (
            <GlobleOmlatForm
              {...{
                omlat: object.bank_omlat,
                omla: object.bank_omla,
                disabled: false,
                onExchangeChange: (value) => {
                  let newObject = {
                    ...object,
                    bank_omla: { ...object.bank_omla, exchange: value },
                    tot_val1: object.val1 * value,
                  };
                  onShow(newObject, formType);
                },
                onChange: (newValue) => {
                  let newObject = {
                    ...object,
                    bank_omla: newValue,
                    tot_val1: object.val1 * newValue.exchange,
                  };
                  onShow(newObject, formType);
                },
                amount: object.val1,
              }}
            />
          )}
        </Grid>
        <Grid item lg={4} md={4} sm={6} xs={12}>
          <Autocomplete
            value={object.emp}
            onChange={(event, newValue) => {
              onChange(null, { name: "emp", value: newValue });
            }}
            id="controllable-states-demo4"
            size="small"
            options={AutoOptions.Users}
            disabled={sto.User_typei == 1 ? false : true}
            getOptionLabel={(option) =>
              typeof option === "string" ? option : option.name
            }
            disableClearable
            renderInput={(params) => (
              <TextField
                id="valueSalesmen"
                {...params}
                label={t("delegate")}
                variant="outlined"
                size="small"
                InputLabelProps={{ className: claslbl.clor }}
              />
            )}
          />
        </Grid>
        <Grid item lg={formType == "edit" ? 10 : 11} md={formType == "edit" ? 10 : 11} sm={12} xs={12}>
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            id="notes"
            label={t("note")}
            className={clasTF.rootEDS}
            InputProps={{ className: clasTF.input }}
            name="notes"
            value={object.notes}
            onChange={(e) =>
              onChange(null, { name: "notes", value: e.target.value })
            }
          />
        </Grid>
        {prmis?.ARCHIVE === true && (
          <Grid item lg={1} md={1} sm={2} xs={2} >
            {formType !== "edit" ?
              (
                <>
                  <Hidden smDown>
                    <Button
                      fullWidth
                      autoFocus
                      variant="contained"
                      onClick={(e) => {
                        openFileDialog();
                      }}
                      style={{
                        background: colors.grey[300],
                        ...{
                          paddingLeft: 0,
                          paddingRight: 0,
                        },
                      }}
                      startIcon={<CloudUpload />}
                    >
                      {"  "}
                    </Button>
                  </Hidden>
                  <input
                    type="file"
                    ref={fileInputRef}
                    multiple
                    style={{ display: "none" }}
                    onChange={handleMultiFilesSelect} />
                </>
              ) : (
                <>
                  <Hidden smDown>

                    <Button
                      fullWidth
                      autoFocus
                      variant="contained"
                      color="#000"
                      onClick={(e) => {
                        handleClickInLine(e);
                      }}
                      style={{
                        background: colors.grey[300],
                        ...{
                          paddingLeft: 0,
                          paddingRight: 0,
                        },
                      }}
                      startIcon={<CloudUpload />}
                    >
                      {"  "}
                    </Button>
                  </Hidden>

                </>
              )}


          </Grid>
        )}
        {/* {menPostion && menuBottonsFile(handleClickOutLine, openFileDialog, handleDownload, menPostion, fileInputRef, handleFileSelect)} */}

        {menPostion && menuBottonsMultiFile(handleClickOutLine, openFileDialog, handleDownload, menPostion, fileInputRef, handleMultiFilesSelect)}


        {formType == "edit" && (
          <Grid item lg={1} md={1} sm={4} xs={12} >
            <Hidden only={["xs"]}>
              <Button
                fullWidth
                autoFocus
                variant="contained"
                color="#000"
                onClick={(e) => {
                  setInfoData({ open: true, })
                }}
                style={{
                  background: colors.grey[300],
                  ...{
                    paddingLeft: 0,
                    paddingRight: 0,
                  },
                }}
              >
                {"القيد" + "  "}
              </Button>
            </Hidden>
          </Grid>
        )}
        {files.length > 0 &&
          <Grid item lg={12} md={12} sm={12} xs={12} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
            <TextField fullWidth variant="outlined" size="small" id="dateT"
              label=""
              type="text"
              className={clasTF.rootCust}
              InputProps={{ className: claslbl.clrBlackTxt, readOnly: true }}
              InputLabelProps={{ className: claslbl.clrBlackLblS }}
              name="doc_no2" value={textfiles}
            />
          </Grid>
        }
        {formType == "edit" && (
          <RestInfoDialog
            infoData={infoData}
            setInfoData={setInfoData}
            res_id={object.rest_id}
            branch={object.branch}
            fromInv={0}
            proc_id={0}
          />
        )}
      </Grid>
    </React.Fragment>
  );
}
